<div class="file-icon-container" [ngClass]="[size, containerClass]">
  <img *ngIf="iconType === 'folder'" src="assets/images/Folder.svg" alt="folder icon" class="file-icon-img" />
  <i *ngIf="iconType === 'pdf'" class="das das-FilePdf"></i>
  <i *ngIf="iconType === 'xls'" class="das das-xlsx"></i>
  <i *ngIf="iconType === 'xlsx'" class="das das-xlsx"></i>
  <i *ngIf="iconType === 'doc'" class="das das-FileDoc"></i>
  <i *ngIf="iconType === 'docx'" class="das das-docx"></i>
  <i *ngIf="iconType === 'csv'" class="das das-csv"></i>
</div>
